import script from "./ServicesOfferedStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesOfferedStep.vue?vue&type=script&setup=true&lang=js"

import "./ServicesOfferedStep.vue?vue&type=style&index=0&id=cc5ba33e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc5ba33e"]])

export default __exports__